export const LOAD = 'community/HOME_LOAD';
export const LOAD_RECAP_SUCCESS = 'community/homepage/LOAD_RECAP_SUCCESS';
